<template>
  <transition name="fade">
    <div class="level3-modal-container">
      <div class="iujp-container">
        <div class="text-title-black text-center">
          KEGIATAN USAHA UTAMA
        </div>
        <div class="kbli-modal-filter-search">
          <form v-on:submit.prevent="noop">
            <div class="input-search">
              <b-input-group>
                <template #append>
                  <b-input-group-text>
                    <strong>
                      <i class="fas fa-times" style="cursor:pointer; marginRight: 10px" @click="resetPlaceholder()" v-if="subSearch !== '' && subSearch"></i>
                      <i class="fas fa-search" style="cursor:pointer"></i>
                    </strong>
                  </b-input-group-text>
                </template>
                <b-form-input placeholder="Cari Sub Kategori" v-model="subSearch" @keyup="searchRun()"></b-form-input>
              </b-input-group>
            </div>
          </form>
        </div>
        <div class="iujp-wrapper text-title-black">
          <div class="iujp-checkbox"></div>
          <div class="iujp-jenis">Kode</div>
          <div class="kbli-desc">Judul</div>
        </div>
        <div class="iujp-wrapper" v-for="(list, index) in subKbli" :key="index">
          <div class="iujp-checkbox">
            <input type="checkbox" :value="list.id" v-model="choosedKbli">
          </div>
          <div class="iujp-jenis">{{ list.kode }}</div>
          <div class="kbli-desc">{{ list.desc }}</div>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="confirm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  data() {
    return {
      subKbli: null,
      subKbliMaster: null,
      subSearch: '',
      selectedSub: [],
      // choosedKbli: []
    }
  },
  mounted() {
      this.getData()
  },
  computed: {
    choosedKbli: {
      get: function() {
        return this.$store.state.searchStore.choosedKbli
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', { name: 'choosedKbli', value: newValue})
      }
    },
  },
  methods: {
    closeModal() {
      const self = this
      this.$store.commit('searchStore/SET_SEARCH_VALUE', { name: 'choosedKbli', value: []})
      self.$store.commit('searchStore/SET_OTHER_MODAL', { name: 'modalKbliFilter', status: false})
    },
    async confirm() {
      const self = this
      const subKbli = `${this.choosedKbli && this.choosedKbli.length > 0 ? this.paramsFormatter('kbli_sub',this.choosedKbli) : ''}`

      await self.$store.commit('level1/SET_DATA_LEVEL1', { query: {kbliSub: subKbli} })
      await this.closeModal()
    },
    async searchRun(id) {
      const self = this
      const search = String(self.subSearch)
      const list = self.subKbliMaster

      let filteredList = []
      for(let i in list) {
        if(list[i].desc.toLowerCase().indexOf(search.toLowerCase()) != -1) {
          filteredList.push(list[i])
        }
      }

      self.subKbli = filteredList
    },
    resetPlaceholder() {
      this.subSearch = []
      this.subKbli = this.subKbliMaster
    },
    async getData() {
      const url = `${api}/api/v1/kbli-sub?page=1&limit=2000`
      try {
        const { data } = await axios({
          method: 'GET',
          url
        })

        if(data.status == 'success') {
          this.subKbli = data.data
          this.subKbliMaster = data.data
        } else {
          throw error
        }
      } catch( error ) {
        this.$store.commit('SET_NOTIF', this.$get(error, 'response.data.message', 'Error'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.kbli-modal-filter-search {
  width: 100%;
  height: auto;
  display: flex; 
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;

  form {
    width: 100%;

    input {
      width: 100%;
    }
  }
}
</style>
